<div class="raise-page">
  <a
    [routerLink]="['/projects', projectId]"
    class="back-link"
    title="Back to project"
    aria-label="Back to project"
  >
    <span class="material-icons">arrow_back</span>
  </a>

  <h1>Raise export request</h1>
  <p class="subtitle">Trace an EPC, select the events to notarise, and address the request to another participant.</p>

  <app-error-banner [message]="participantsError()" />

  @if (isPlatformCaller) {
    <section class="card">
      <h2>1. Sender</h2>
      <p class="hint">
        You're acting as a superadmin — pick which participant is raising this request.
      </p>

      @if (isLoadingParticipants()) {
        <p class="hint">Loading participants...</p>
      } @else if (exporterCandidates().length === 0) {
        <app-empty-state message="No participants on this project yet." />
      } @else {
        <app-company-select
          [(ngModel)]="exporterCompanyId"
          (ngModelChange)="onExporterChange()"
          name="exporterCompanyId"
          label="Exporter company"
          [options]="exporterCandidates()"
        />
      }
    </section>
  }

  <section class="card">
    <h2>{{ isPlatformCaller ? '2' : '1' }}. Recipient</h2>

    @if (isLoadingParticipants()) {
      <p class="hint">Loading participants...</p>
    } @else if (isPlatformCaller && !exporterCompanyId) {
      <p class="hint">Pick a sender first.</p>
    } @else if (importerCandidates().length === 0) {
      <app-empty-state message="No other participants on this project yet." />
    } @else {
      <app-company-select
        [(ngModel)]="importerCompanyId"
        name="importerCompanyId"
        label="Importer company"
        [options]="importerCandidates()"
      />
    }
  </section>

  <section class="card">
    <h2>{{ isPlatformCaller ? '3' : '2' }}. Trace the EPC</h2>

    <div class="trace-form">
      <mat-form-field appearance="outline" class="epc-field">
        <mat-label>EPC</mat-label>
        <input matInput [(ngModel)]="epc" name="epc" placeholder="urn:epc:id:sgtin:C00239.MD3148.QTJYIZYC73" />
      </mat-form-field>
      <button
        mat-stroked-button
        class="trace-btn"
        [class.trace-btn--active]="canTrace"
        (click)="trace()"
        [disabled]="!canTrace"
      >
        {{ isTracing() ? 'Tracing...' : 'Trace' }}
      </button>
    </div>

    @if (traceUnavailable()) {
      <p class="hint">Tracing isn't configured in this environment yet.</p>
    }
    <app-error-banner [message]="traceError()" />
  </section>

  @if (isTracing()) {
    <section class="card card--tracing">
      <app-trace-loader [epc]="epc" />
    </section>
  }

  @if (events().length > 0) {
    <section class="card card--reveal">
      <h2>{{ isPlatformCaller ? '4' : '3' }}. Select events</h2>

      <table>
        <thead>
          <tr>
            <th>
              <mat-checkbox
                [checked]="allSelected"
                [indeterminate]="someSelected"
                (change)="toggleSelectAll()"
                title="Select all events"
              />
            </th>
            <th>Event type</th>
            <th>Biz step</th>
            <th>Location</th>
            <th>Time</th>
          </tr>
        </thead>
        <tbody>
          @for (event of events(); track event.eventId; let i = $index) {
            <tr (click)="toggleEvent(event.eventId)" class="event-row" [style.--i]="i">
              <td>
                <mat-checkbox
                  [checked]="isSelected(event.eventId)"
                  (click)="$event.stopPropagation()"
                  (change)="toggleEvent(event.eventId)"
                />
              </td>
              <td>{{ event.eventType }}</td>
              <td>{{ event.bizStep }}</td>
              <td>{{ event.bizLocation }}</td>
              <td>{{ event.eventTime | date: 'medium' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </section>
  }

  <app-error-banner [message]="submitError()" />

  <button mat-flat-button class="submit-btn" (click)="submit()" [disabled]="!canSubmit">
    {{ isSubmitting() ? 'Submitting...' : 'Submit & write to chain' }}
  </button>
</div>

@if (isSubmitting()) {
  <app-globe-loader title="Raising export request" [steps]="submitSteps" />
}
